import React from 'react';
import { useParams } from 'react-router-dom';
import { useBookingEvents } from '../../../../hooks/accommodation';
import { BookingEventTimeline } from './BookingEventTimeline';

export const BookingActivityTimelineCard: React.FC = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const { data: events = [] } = useBookingEvents(bookingId);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 space-y-4">
      <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-500 pb-2 border-b border-gray-100">
        Activity
      </h4>
      <BookingEventTimeline events={events} />
    </div>
  );
};
